import React from "react";
import MenuProvider from "./MenuProvider";
import {NavLink} from "react-router-dom";
import Button from "./Button";

import times from "../assets/times.svg";

//const TopNav = (props, {hideMenu}) => {
const TopNav = (props) => {
	
 function defaultLogOutButton(e) {
     //Logout clicked; clear out local storage 
     
     sessionStorage.removeItem("isLoggedIn");
     sessionStorage.removeItem("userRoles");
     sessionStorage.removeItem("userRole");
     sessionStorage.clear();
     
    if (props.buttonAction === undefined || props.buttonAction === null) {

    } else {

      props.buttonAction(e);
    } 
  }
  
  // compare allowAccess and userRole
  // if userRole in the allowAccess Array, return true, show menu item
  function showMenuItem(allowAccess, text, showInMenu) {
    let showMenu = false;
    let userRole = sessionStorage.getItem("userRole");
    //let isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
    if (((showInMenu) && (text !== "")) && 
    	((allowAccess.filter((r) => r.includes("ALL")).length > 0) ||
    	 (allowAccess.filter((r) => r.includes(userRole)).length > 0))) {
      	showMenu = true;
    }
    // return true;
    
    return showMenu;
  }

	  const navigation = props.navMap;
	
	  const hasShowInMenuTrue = navigation.some(item => item.showInMenu === true); 
	  const hideMobileMenu = props.userName.trim() === "" &&  (!hasShowInMenuTrue);
	
	  // this is Consumer
	  return (
		<div>
		    <MenuProvider.Consumer>
	        {(ShowMenu) => (
	          <div
	            className={`header__menuBar ${ShowMenu ? "show" : "hide"} ${hasShowInMenuTrue ? "" : "header__menuBar_zero_item"}`}
	            id="menuBar"
	          >
	
			  {/* this icon is for mobile view */}
			  <div className={hideMobileMenu ? "hide_div":"header__menuItem_title"}>
	            <img src={times} alt="Close Menu" onMouseUp={props.hideMenu} />
	            <span>{props.shortTitle}</span>
	          </div>
               
	          
	
					
			     {/* using a loop build the menu from json */}
              {navigation.map(({ to, text, allowAccess, showInMenu }, i) => (
                <NavLink
                  //style={text !== "" && showInMenu ? {} : { display: "none" }}
                  style={ showMenuItem(allowAccess, text, showInMenu) ? {} : { display: "none" }}
                  to={to}                  
                  activeClassName="header__menuItem_active"
                  id={"menuItem_" + i++}
                  onClick={props.hideMenu}
                  key={i}
                  className={"header__menuItem"}
                >
                  {text}
                </NavLink>
              ))}
		          
				{/* this log out button for mobile view */}
          <div className={hideMobileMenu ?"hide_div" : "header__menuItem_logout"}>
            <span>{props.userName}</span>
            {/* <button className="button button--primary">Sign out</button> */}
            <Button
              text={props.buttonLabel}
              styleName="button button--secondary"
              onClick={defaultLogOutButton}
              id={"header_components_logout_button_mobile"}
            />
          </div>
	
		        </div>
		      )}
		    </MenuProvider.Consumer>
	
		</div>
	  );
};

export default TopNav;